































































import { Vue, Component } from 'vue-property-decorator';

@Component
export default class Links extends Vue {
    dialog: boolean = false;
    toRetire: any = null;
    snackMessage: string = "";
    copySnack: boolean = false;

    async mounted() {
      await this.$store.dispatch('$destinations/select', this.$route.params.did);
      await this.$store.dispatch('$links/reload', this.$route.params.did);
    }

    copyToClipboard(el: string) {
      this.snackMessage = "Unable to copy link";

      const testingCodeToCopy = document.querySelector(el);
      if (testingCodeToCopy) {
        try {
          (testingCodeToCopy as any).select();
          const successful = document.execCommand('copy');
          this.snackMessage = "Link copied to clipboard";
        } catch (err) {
        }
      }
      this.copySnack = true;
    }

    async askRetire(link: any) {
      this.toRetire = link;
      this.dialog = true;
    }

    async retire() {
      console.log("retire link", this.toRetire);
      await this.$store.dispatch('$links/retire', this.toRetire);
      this.toRetire = null;
      this.dialog = false;
    }
}
